import React from "react";

let FortCreatorInfo = require("../components/fort-creator-info"),
    FortCustomerInfoWrapper = require("../components/fort-customer-info"),
    FortCollectionInfo = require("../components/fort-collection-detail"),
    FortIconInfo = require("../components/fort-icon-detail");

class FortWrapper extends React.Component {
    render() {
        let creatorInfo = this.renderCreatorInfo(),
            customerInfo = this.renderCustomerInfo(),
            collectionInfo = this.renderCollectionInfo(),
            iconInfo = this.renderIconInfo();

        return (
            <div>
                {customerInfo}
                {creatorInfo}
                {collectionInfo}
                {iconInfo}
            </div>
        );
    }

    renderCustomerInfo() {
        if (this.props.params.creatorId && this.props.params.invoices) {
            return (
                <FortCustomerInfoWrapper
                    creatorId={this.props.params.creatorId}
                    chargeId={this.props.params.chargeId}
                />
            );
        } else {
            return null;
        }
    }

    renderCreatorInfo() {
        if (this.props.params.creatorId && !this.props.params.invoices) {
            return <FortCreatorInfo creatorId={this.props.params.creatorId} />;
        } else {
            return null;
        }
    }

    renderCollectionInfo() {
        if (this.props.params.collectionId) {
            return <FortCollectionInfo collectionId={this.props.params.collectionId} />;
        } else {
            return null;
        }
    }

    renderIconInfo() {
        if (this.props.params.iconId) {
            return <FortIconInfo iconId={this.props.params.iconId} />;
        } else {
            return null;
        }
    }
}

module.exports = FortWrapper;
